import { throwIfPromiseError } from "./_internal/error.js";
import { isAsyncIterable, isIterable } from "./_internal/utils.js";
import map from "./Lazy/map.js";
import takeUntil from "./Lazy/takeUntil.js";
import not from "./not.js";
import pipe from "./pipe.js";
import reduce from "./reduce.js";
function every(f, iterable) {
    if (iterable === undefined) {
        return (iterable) => {
            return every(f, iterable);
        };
    }
    if (isIterable(iterable)) {
        return pipe(map((a) => throwIfPromiseError(f(a)), iterable), takeUntil(not), (acc) => reduce((a, b) => a && b, true, acc), (a) => a !== null && a !== void 0 ? a : true, Boolean);
    }
    if (isAsyncIterable(iterable)) {
        return pipe(map(f, iterable), takeUntil(not), (acc) => reduce((a, b) => a && b, true, acc), (a) => a !== null && a !== void 0 ? a : true, Boolean);
    }
    throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
export default every;
//# sourceMappingURL=every.js.map